import { render, staticRenderFns } from "./IconRouter.vue?vue&type=template&id=5030c2d6"
import script from "./IconRouter.vue?vue&type=script&lang=js"
export * from "./IconRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports